import React, { useState, useEffect , useContext } from "react";
import { Card, Col, Row, Spinner, Table } from "@themesberg/react-bootstrap";
import { useTranslation } from "react-i18next";
import { useClaims } from "./hooks/useClaims";
import ClaimRow from "./allClaims/ClaimRow";
import Filter from "../Filter";
import { ToastAlert } from "../ToastAlert";
import ViewDetailsPopup from "../ViewDetailsPopup";
import PaginationControls from "./allClaims/PaginationControls";
import API from "../../utils/api";
import { Modal } from '@themesberg/react-bootstrap';
import ChatModal from "../ChatModal";
import { UnreadContext } from "../../utils/UnreadContext";
export const AllClaims = ({ filterPaymentStatus, hasChat , unreadFirst }) => {
  const { t } = useTranslation();
  const {
    claimsData,
    totalPages,
    currentPage,
    setCurrentPage,
    loading,
    error,
    setFilters,
    fetchClaims,
  } = useClaims({ filterPaymentStatus, hasChat , unreadFirst });
  // const [unreadCounts, setUnreadCounts] = useState({});
   const { unreadUsers, unreadCounts, fetchUnreadCounts } = useContext(UnreadContext);
  const [alert, setAlert] = useState({
    show: false,
    message: "",
    variant: "info",
  });
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);
  const [selectedClaimId, setSelectedClaimId] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState({});

  const showAlert = (message, variant = "info") =>
    setAlert({ show: true, message, variant });

  const handleViewClick = (claimId) => {
    setSelectedClaimId(claimId);
    setShowDetailsPopup(true);
  };
  const [showChatModal, setShowChatModal] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const handleChatClick = async (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setShowChatModal(true);

    try {
      // 🔥 Call backend to mark messages as read
      await API.put(`/mark-as-read/${invoiceId}`);

      // 🔄 Refresh unread counts visually
      fetchUnreadCounts();
    } catch (err) {
      console.error("Failed to mark messages as read", err);
    }
  };

  

  // const handleSubmitt = async (claimId) => {
  //   const file = uploadedFiles[claimId]; // must match the key from handleFileUpload
  //   if (!file) {

  //     showAlert("Please select a file first", "danger");

  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("mandate", file);

  //   try {
  //     await API.patch(`/claims/getsingle/${claimId}/reupload`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  //     showAlert("File submitted successfully!", "success");
  //     fetchClaims(currentPage);
  //   } catch (err) {
  //     console.error("Failed to upload mandate", err);
  //     showAlert("Failed to upload file. Please try again.", "danger");
  //   }
  // };
  const handleSubmitt = async (claimId) => {
    try {
      await API.patch(`/claims/getsingle/${claimId}/reuploadd`);
      showAlert("Enforcement allowed successfully!", "success");
      fetchClaims(currentPage);
    } catch (err) {
      console.error("Error updating claim", err);
      showAlert("Failed to update claim. Please try again.", "danger");
    }
  };

  const handleStart = async (claimId) => {
    try {
      await API.patch(`/claims/${claimId}/promote`);
      showAlert("Claim started successfully!", "success");
      fetchClaims(currentPage);
    } catch (err) {
      console.error("Failed to started claim", err);
      showAlert("Failed to started claim. Please try again.", "danger");
    }
  };
  const handleFileUpload = (claimId, event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploadedFiles((prev) => ({
      ...prev,
      [claimId]: file, // store under claimId key
    }));
  };
  useEffect(() => {
    fetchUnreadCounts();
  }, [currentPage]);


  return (
    <>
      <ToastAlert
        show={alert.show}
        onClose={() => setAlert({ ...alert, show: false })}
        message={alert.message}
        variant={alert.variant}
      />

      <Card border="light" className="shadow-sm mt-4">
        <Card.Header>
          <Row className="align-items-center justify-content-between">
            <Col md={3}>
              <h5 style={{ marginBottom: 0 }}>{t("submittedClaimsText")}</h5>
            </Col>
            <Col md={9} className="d-flex justify-content-end">
              <Filter
                fields={[
                  {
                    name: "status",
                    label: "",
                    type: "select",
                    options: [
                      { value: "Waiting for Admin Action", label: t("statuses.waitingAdminAction.label") },
                      { value: "In Progress", label: t("statuses.inProgress.label") },
                      { value: "Waiting", label: t("statuses.waiting.label") },
                      { value: "Rejected", label: t("statuses.rejected.label") },
                      { value: "debtor has paid, payment coming soon", label: t("statuses.debtorPaid.label") },
                      { value: "Installment payment agreement in place", label: t("statuses.installmentAgreement.label") },
                      { value: "court dunning procedure", label: t("statuses.courtDunning.label") },
                      { value: "we contact the debtor", label: t("statuses.contactDebtor.label") },
                      { value: "enforcement order obtained", label: t("statuses.enforcementOrder.label") },
                      { value: "case closed", label: t("statuses.caseClosed.label") },
                      { value: "cancellation", label: t("statuses.cancelled.label") },
                      // ...
                    ],
                    col: 8,
                  },
                  {
                    name: "claimName",
                    label: "",
                    type: "text",
                    placeholder: t("filtterClaimName"),
                    col: 8,
                  },
                  {
                    name: "fileReference",
                    label: "",
                    type: "text",
                    placeholder: t("filtterFileRefrence"),
                    col: 8,
                  },
                ]}
                onFilterChange={(filters) => {
                  setFilters(filters);
                  setCurrentPage(1);
                  fetchClaims(1, filters);
                }}
              />
            </Col>
          </Row>
        </Card.Header>

        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-danger text-center py-3">{error}</div>
        ) : (
          <>
            <Table responsive className="table-flush align-middle">
              <thead className="thead-light">
                <tr>
                  <th>{t("tableHeaders.claimName")}</th>
                  <th>{t("tableHeaders.uploadedBilling")}</th>
                  {/* <th>{t("tableHeaders.uploadMandate")}</th> */}
                  <th>{t("Amount")}</th>
                  <th>{t("tableHeaders.status")}</th>
                  <th className="text-center" style={{ width: "80px" }}>
                    {t("tableHeaders.actions")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {claimsData.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center">
                      No claims found.
                    </td>
                  </tr>
                ) : (
                  claimsData.map((claim) => (
                    <ClaimRow
                      key={claim._id}
                      claim={claim}
                      uploadedFiles={uploadedFiles}
                      setUploadedFiles={setUploadedFiles}
                      showAlert={showAlert}
                      fetchClaims={fetchClaims}
                      handleViewClick={handleViewClick}
                      handleSubmitt={handleSubmitt}
                      handleFileUpload={handleFileUpload}
                      handleStart={handleStart}
                      handleChatClick={handleChatClick}
                      unread={unreadCounts[claim._id] || 0}
                    />
                  ))
                )}
              </tbody>
            </Table>
            <Modal show={showChatModal} onHide={() => setShowChatModal(false)} centered size="lg">
              <Modal.Header closeButton>
                <Modal.Title>{t("ChatHeading")} </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ChatModal invoiceId={selectedInvoiceId} />
              </Modal.Body>
            </Modal>

            <ViewDetailsPopup
              show={showDetailsPopup}
              onClose={() => setShowDetailsPopup(false)}
              claimId={selectedClaimId}
              isAdmin={false}
            />

            <PaginationControls
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </>
        )}
      </Card>
    </>
  );
};
